// The guest's session token, held in localStorage with an in-memory fallback.
//
// A write that fails (quota full, storage blocked, some private modes) used to
// throw out of the very first request, and the home page reported it as
// "Unable to connect to Moksy services — check your connection". The visitor's
// connection was fine and nothing they could do would fix it. With the
// fallback the journey works for as long as the tab lives; only a reload loses
// it, which is the honest limit of having nowhere to keep it.
const KEY = 'guestToken';
let memory = null;

export const readGuestToken = () => {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored) return stored;
  } catch (_) { /* storage unreadable — fall through to memory */ }
  return memory;
};

export const writeGuestToken = (token) => {
  if (!token) return;
  // Memory holds the token ONLY when storage refused it. When the write works,
  // storage is the single source of truth (another tab, or a clear, must win).
  try { localStorage.setItem(KEY, token); memory = null; } catch (_) { memory = token; }
};

export const clearGuestToken = () => {
  memory = null;
  try { localStorage.removeItem(KEY); } catch (_) { /* nothing stored to remove */ }
};

/** True when the token could not be written to storage and lives in memory only. */
export const guestTokenIsMemoryOnly = () => Boolean(memory);
